/*
  Sticky add-to-cart bar (narrow screens only).

  Shows the bar once the real Add to cart button has left the viewport, and
  keeps its price, label and disabled state copied from the live product form
  so a variant change or a sold-out variant reaches the bar without this file
  knowing anything about variants.

  Everything is a mirror. The button submits the page's existing product form
  through its `form` attribute, so Dawn's product-form element handles the add
  and opens the cart drawer as usual.
*/
(function () {
  var MOBILE = '(max-width: 749px)';

  function init(bar) {
    var info = document.getElementById(bar.dataset.formSource);
    var priceSource = document.getElementById(bar.dataset.priceSource);
    var inlineButton = info && info.querySelector('.product-form__submit');
    var priceTarget = bar.querySelector('[data-ge-sticky-price]');
    var stickyButton = bar.querySelector('[data-ge-sticky-submit]');

    // Without a real button to mirror there is nothing to sync or to submit,
    // so leave the bar hidden rather than shipping a control that lies.
    if (!inlineButton || !stickyButton) return;

    var mq = window.matchMedia(MOBILE);
    var inlineVisible = true;

    function syncPrice() {
      if (!priceSource || !priceTarget) return;
      // The price block carries visually-hidden labels ("Regular price") that
      // would read as noise in a one-line bar; the price text itself is what
      // the shopper needs here.
      var visible = priceSource.querySelector('.price-item--sale, .price-item--regular');
      priceTarget.textContent = (visible ? visible.textContent : priceSource.textContent)
        .replace(/\s+/g, ' ')
        .trim();
    }

    function syncButton() {
      var disabled = inlineButton.hasAttribute('disabled');
      if (disabled) {
        stickyButton.setAttribute('disabled', 'disabled');
      } else {
        stickyButton.removeAttribute('disabled');
      }
      var label = inlineButton.querySelector('span');
      var text = (label ? label.textContent : inlineButton.textContent).replace(/\s+/g, ' ').trim();
      if (text) stickyButton.textContent = text;
    }

    function render() {
      var show = mq.matches && !inlineVisible;
      bar.hidden = !show;
      bar.classList.toggle('is-visible', show);
    }

    syncPrice();
    syncButton();

    // Dawn replaces the price block and the buy buttons wholesale on a variant
    // change, so watch the container rather than the nodes themselves.
    if (window.MutationObserver) {
      new MutationObserver(function () {
        syncPrice();
        syncButton();
      }).observe(info, { childList: true, subtree: true, attributes: true });
    }

    if (window.IntersectionObserver) {
      new IntersectionObserver(
        function (entries) {
          inlineVisible = entries[0].isIntersecting;
          render();
        },
        { threshold: 0 }
      ).observe(inlineButton);
    }

    if (mq.addEventListener) {
      mq.addEventListener('change', render);
    } else if (mq.addListener) {
      mq.addListener(render);
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-ge-sticky-buy]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
